import { Component, Input } from '@angular/core';
import { NewsfeedResult } from '@planone/bau365/data-access-newsfeed';
import { WatchlistPageContext } from '@planone/bau365/data-access-user';

@Component({
  selector: 'bau365-result-teaser',
  templateUrl: './result-teaser.component.html',
})
export class ResultTeaserComponent {
  @Input() item: NewsfeedResult | undefined | null;
  @Input() pageContext: WatchlistPageContext | undefined;
  @Input() markAsNew: boolean | undefined;
  @Input() size: string | undefined | null;
  @Input() insightsId: string | undefined | null;
}
